import React from 'react'

import useFetch from '../../../hook/useFetch'
import api from '../../../../api'
import { authHeader } from '../../../../_helpers/auth-header'

function DrawerForm({ action, setAction }) {
    const {
        data: { id, title, info, service_categories_id, service_states_id },
        behavior,
    } = action

    const initialState = {
        title: behavior === 'update' ? title : '',
        info: behavior === 'update' ? info : '',
        service_categories_id:
            behavior === 'update' ? service_categories_id : 0,
        service_states_id: behavior === 'update' ? service_states_id : 0,
    }

    const { data: serviceCategory } = useFetch('/service-categories')
    const { data: serviceState } = useFetch('/service-states')

    const [form, setForm] = React.useState({ ...initialState })
    const [isError, setIsError] = React.useState(null)

    function handleChange({ target }) {
        const { id, value } = target
        setForm({ ...form, [id]: value })
    }

    function update(id) {
        api.put(
            `/services/${id}`,
            {
                title: form.title,
                info: form.info,
                service_categories_id: form.service_categories_id,
                service_states_id: form.service_states_id,
            },
            { authHeader }
        )
            .then((response) => {
                if (response.status === 200) {
                    setAction({
                        ...action,
                        behavior: '',
                        drawer: false,
                    })
                }
            })
            .catch((error) => {
                let message =
                    typeof error.response !== 'undefined'
                        ? error.response.data.message
                        : error.message
                setIsError(message)
            })
    }

    function create() {
        api.post(
            '/services',
            {
                title: form.title,
                info: form.info,
                service_categories_id: form.service_categories_id,
                service_states_id: form.service_states_id,
            },
            { authHeader }
        )
            .then((response) => {
                if (response.status === 200) {
                    setAction({
                        ...action,
                        behavior: '',
                        drawer: false,
                    })
                }
            })
            .catch((error) => {
                let message =
                    typeof error.response !== 'undefined'
                        ? error.response.data.message
                        : error.message
                setIsError(message)
            })
    }

    function handleSubmit(e) {
        e.preventDefault()

        if (behavior === 'create') {
            create()
            return
        }

        if (behavior === 'update') {
            update(id)
            return
        }
    }

    return (
        <form onSubmit={handleSubmit}>
            <span className="form-group mb-4 d-block">
                <label>Título</label>
                <input
                    className="form-control"
                    id="title"
                    type="text"
                    onChange={handleChange}
                    value={form.title}
                    required
                />
            </span>

            <span className="form-group mb-4 d-block">
                <label>Informação</label>
                <input
                    className="form-control"
                    id="info"
                    type="text"
                    onChange={handleChange}
                    value={form.info}
                    required
                />
            </span>

            <span className="form-group mb-4 d-block">
                <label>Categoria</label>
                <select
                    id="service_categories_id"
                    className="form-select"
                    onChange={handleChange}
                    value={form.service_categories_id}
                >
                    <option value="0" disabled>
                        Selecione a categoria
                    </option>
                    {serviceCategory.map((item) => (
                        <option key={item.id} value={item.id}>
                            {item.title}
                        </option>
                    ))}
                </select>
            </span>

            <span className="form-group mb-4 d-block">
                <label>Estado</label>
                <select
                    id="service_states_id"
                    className="form-select"
                    onChange={handleChange}
                    value={form.service_states_id}
                >
                    <option value="0" disabled>
                        Selecione o Estado
                    </option>
                    {serviceState.map((item) => (
                        <option key={item.id} value={item.id}>
                            {item.title}
                        </option>
                    ))}
                </select>
            </span>

            <span className="form-group">
                <button className="btn btn-primary">
                    {behavior === 'create' ? 'Salvar' : 'Atualizar'}
                </button>
            </span>

            {isError && (
                <div className="row">
                    <div className="col">
                        <p className="mt-2 bg-danger text-white rounded p-3">
                            {isError[Object.keys(isError)]}
                        </p>
                    </div>
                </div>
            )}
        </form>
    )
}

export default DrawerForm
